import { esgCodes } from '@/data/esgCode';
import Filters from '@/components/analyticsPage/tabPanels/components/drawers/components/Filters';
import { useMultiIndexQuery } from '@/components/analyticsPage/tabPanels/components/drawers/indexDrawer/components/components/multiIndex/hooks/useMultiIndexQuery';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DatePicker from '@/components/ui/datepicker';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDownIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

const MultiIndex = () => {
  const query = useSelector((state: any) => state.analytics.indexQuery.index.multiIndex);
  const [setQuery] = useMultiIndexQuery();
  const [t] = useTranslation('analytics');

  return (
    <div className="space-y-4 m-4">
      <div className="w-full space-y-1">
        <div className="font-medium">{t('Time window')}</div>
        <div className="flex items-center gap-2">
          <DatePicker
            className="w-full"
            value={query.from}
            onChange={(e) => setQuery({ from: e })}
          />
          <DatePicker className="w-full" value={query.to} onChange={(e) => setQuery({ to: e })} />
        </div>
      </div>
      <div className="font-medium">{t('Data type')}</div>
      <div>
        {/* <FormControlLabel
              value={1}
              control={<Radio />}
              label={t('SASB Materiality')}
              sx={{ padding: '0px 12px' }}
              checked={
                query.dataType === 0 &&
                (query.compositeScore.materiality === 1 || query.compositeScore.materiality === '1')
              }
              onClick={() => setQuery({ dataType: 0, compositeScore: { materiality: 1 } })}
            /> */}
        <RadioGroup
          defaultValue="0"
          value={String(query.dataType)}
          onValueChange={(e) => setQuery({ dataType: e })}
        >
          <div className="flex items-center gap-3 mb-2">
            <RadioGroupItem value={`0`} id="0" />
            <Label htmlFor="0">{t('SASB Materiality')}</Label>
          </div>
          <div className="flex items-center gap-3 mb-2">
            <RadioGroupItem value={`1`} id="1" />
            <Label htmlFor="1">{t('ESG Category')}</Label>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger disabled={query.dataType === '0'}>
              <Button variant="outline" className="w-full flex items-center justify-between">
                {esgCodes.find(
                  (el) => String(el.general_issue_code) === query.individualScore.esgCode,
                )?.general_issue_name || t('Select a ESG Category')}
                <ChevronDownIcon className="ml-2 h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              {esgCodes.map((el, i) => {
                return (
                  <DropdownMenuItem
                    key={i}
                    onClick={() =>
                      setQuery({ individualScore: { esgCode: String(el.general_issue_code) } })
                    }
                  >
                    {el.general_issue_name}
                  </DropdownMenuItem>
                );
              })}
            </DropdownMenuContent>
          </DropdownMenu>
        </RadioGroup>
      </div>

      {/* <FormControl sx={{ ml: 1.5 }}>
            <RadioGroup
              value={query.dataType}
              onChange={(e) => setQuery({ dataType: Number(e.target.value) })}
            > */}
      {/* <FormControlLabel value={0} control={<Radio />} label={t('Materiality')} />
              <FormControl size="small" disabled={query.dataType !== 0} sx={{ width: '100%' }}>
                <InputLabel>Select a Materiality</InputLabel>
                <Select
                  label="Select a ESG Category"
                  value={query.compositeScore.materiality}
                  onChange={(e) => setQuery({ compositeScore: { materiality: e.target.value } })}
                >
                  <MenuItem value={0}>Data-driven Materiality</MenuItem>
                  <MenuItem value={1}>SASB Materiality</MenuItem>
                </Select>
              </FormControl> */}
      {/* <FormControlLabel value={1} control={<Radio />} label={t('ESG Category')} />
              <FormControl size="small" disabled={query.dataType !== 1} sx={{ width: '100%' }}>
                <InputLabel>Select a ESG Category</InputLabel>
                <Select
                  label="Select a ESG Category"
                  value={query.individualScore.esgCode}
                  MenuProps={{ sx: { height: '350px' } }}
                  onChange={(e) => setQuery({ individualScore: { esgCode: e.target.value } })}
                >
                  {esgCodes.map((el, i) => (
                    <MenuItem value={el.general_issue_code} key={i}>
                      {el.general_issue_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </RadioGroup>
          </FormControl> */}
      <div className="space-y-0">
        <div className="font-medium">{t('Index')}</div>
        <Filters filters={query.filters} setQuery={setQuery} originalFilter={query.filters} />
      </div>
    </div>
  );
};

export default MultiIndex;
